import {useState} from 'react';
import useTariff, {TariffAddition} from './useTariff';
import Button from 'components/Button';
import useAuth from 'hooks/useAuth';
import {get} from 'lodash';
import {useHistory} from 'react-router-dom';
import plansIds from 'constants/plans';
import styles from './PricingPlans.module.scss';
import StatusBadge from 'components/StatusBadge';
import classNames from 'classnames';
type ItemProps = {
  id: string;
  title: string;
  price: number;
  people: string;
  addition: TariffAddition[] | undefined;
  choosen: string;
  initialCount?: number;
  setChoosen?: (value: string) => void;
  setCounter?: (value: number) => void;
};

export const PlanCard = ({
  title,
  price,
  people,
  addition = [],
  id,
  initialCount,
  choosen,
  setChoosen,
  setCounter,
}: ItemProps) => {
  const {currentUser} = useAuth();
  const {push} = useHistory();
  const [count, setCount] = useState(
    initialCount
      ? initialCount
      : get(currentUser, 'company.plan.plan_id') === id
      ? get(currentUser, 'company.plan.subscription_quantity', 1)
      : 1
  );

  const decrementCount = () => {
    if (setCounter) {
      setCounter(Math.max(count - 1, 1));
    }
    setCount((pr) => Math.max(pr - 1, 1));
  };

  const incrementCount = () => {
    if (setCounter) {
      setCounter(count + 1);
    }
    setCount((pr) => pr + 1);
  };

  const handlePlanSelection = async () => {
    const isPlanNotSelected = choosen !== id;

    if (isPlanNotSelected) {
      setChoosen?.(id);
    } else {
      const tariffData = {
        product_id: id,
        count,
        name: title,
        price,
        addition,
        description: people,
      };

      sessionStorage.setItem('tariff', JSON.stringify(tariffData));
      push('/settings/billing/update');
    }
  };

  const getButtonText = () => {
    const isPlanSelected = choosen === id;
    const isCurrentPlan = get(currentUser, 'company.plan.plan_id') === id;

    if (!isPlanSelected) {
      return 'Choose plan';
    }

    return isCurrentPlan ? 'Update' : 'Buy plan';
  };

  return (
    <div
      className={classNames(styles.card, {
        [styles.activePlan]:
          get(currentUser, 'company.plan.plan_id') === id || !!setCounter,
      })}
    >
      {get(currentUser, 'company.plan.plan_id') === id && (
        <div className={styles.current}>
          <StatusBadge color="default">Current</StatusBadge>
        </div>
      )}
      <h3>{title}</h3>
      <p>
        Start with <b style={{fontSize: 25}}>${price}</b> for user per month for
      </p>

      {addition?.map((item) => {
        return (
          <p className={styles.addition} key={item.name}>
            {item.name}
          </p>
        );
      })}
      <p className={styles.price}>
        Total: ${price * count || '0'}
        /month
      </p>
      {choosen === id && id !== plansIds[0] && (
        <div className={styles.counterContainer}>
          <div className={styles.counter}>
            <p onClick={decrementCount} className={styles.counterItem}>
              -
            </p>
            <p className={styles.count}>{count}</p>
            <p onClick={incrementCount} className={styles.counterItem}>
              +
            </p>
          </div>
        </div>
      )}
      {!!setChoosen && (
        <Button onClick={handlePlanSelection} className={styles.button}>
          {getButtonText()}
        </Button>
      )}
    </div>
  );
};

const PricingPlans = () => {
  const {currentUser} = useAuth();
  const [choosen, setChoosen] = useState(
    get(currentUser, 'company.plan.plan_id', '')
  );

  const {data} = useTariff();

  return (
    <div className={styles.container}>
      <h2>Choose your plan</h2>
      <p>All paid plans include unlimited projects, clients, and invoices.</p>
      <div className={styles.plans}>
        {data.map((item) => {
          return (
            <PlanCard
              key={item.id}
              id={item.id}
              choosen={choosen}
              setChoosen={setChoosen}
              title={item.name}
              price={get(item, 'prices[0].unit_amount_decimal', 0)}
              addition={item.marketing_features}
              people={item.description}
            />
          );
        })}
      </div>

      <div className={styles.footer}>
        <p>
          At any point, You can mark a user inactive which can lower your
          monthly billing amount. Questions ?{' '}
          <a href="#free">Get in touch with us.</a>
        </p>
      </div>
    </div>
  );
};

export default PricingPlans;
